// extracted by mini-css-extract-plugin
export default {"textLink":"NewAccount_textLink__EbTkN","small":"NewAccount_small__slPEG","socials":"NewAccount_socials__91qDA"};